import React from 'react'
import BackgroundImg from 'App/assets/survey-background.png'
import { ReactComponent as WelbeSlogan } from 'App/assets/welbe-slogan.svg'
import {
	AcceptanceContainer,
	ActionContainer,
	BoldText,
	CompanyBrand,
	LogoBrands,
	PresentationContainer,
	SurveyContainer,
	Title,
} from './Survey.styles'
import { Button, Checkbox } from '@welbe/web-design-system'
import { useSurvey } from './Survey.hooks'
import { Loading } from 'App/components/Loading/Loading'
import { ErrorInfo } from 'App/components/ErrorInfo/ErrorInfo'
import { ExpiredInfo } from 'App/components/ExpiredInfo/ExpiredInfo'

export const Survey = (): JSX.Element => {
	const {
		handleNavigate,
		isGlobalLoading,
		isCampaignExpired,
		hasGlobalError,
		companySurvey,
		setCompanySurvey,
		showPrivacySettings,
	} = useSurvey()

	const handleCheckboxChange = (checked: boolean) => {
		setCompanySurvey({
			...companySurvey,
			employee: {
				isProfileCompleted: checked,
			},
		})
	}

	if (isGlobalLoading) return <Loading />
	if (hasGlobalError) return <ErrorInfo />
	if (isCampaignExpired) return <ExpiredInfo />

	return (
		<SurveyContainer>
			<LogoBrands>
				<WelbeSlogan />
				<CompanyBrand>
					<img src={companySurvey.campaign.company.logoUrl} />
				</CompanyBrand>
			</LogoBrands>

			<PresentationContainer>
				<Title fontWeight={600}>
					<p>
						<BoldText>{companySurvey.campaign.company.fancyName}</BoldText>{' '}
						junto con Welbe nos preocupamos por tu salud no solo física sino
						mental.
					</p>
				</Title>
				<img src={BackgroundImg} width="100%" />
				<Title fontWeight={500}>
					<p>
						La NOM-035 es una norma enfocada en prevenir factores de riesgo
						psicosocial y fomentar entornos laborales positivos así como un
						desempeño adecuado para ti y tus compañeros.
					</p>
				</Title>
				{showPrivacySettings && (
					<AcceptanceContainer>
						<Checkbox
							id="acceptance"
							value={Boolean(companySurvey?.employee?.isProfileCompleted)}
							topDistance="4px"
							onChange={value => handleCheckboxChange(value)}
						/>
						<p>
							Acepto los{' '}
							<a
								href="https://terminosycondiciones.welbecare.com/"
								target="_blank"
								rel="noreferrer"
							>
								Términos y condiciones
							</a>{' '}
							de Welbe, así como el{' '}
							<a
								href="https://avisoprivacidad.welbecare.com/"
								target="_blank"
								rel="noreferrer"
							>
								Aviso de privacidad
							</a>
						</p>
					</AcceptanceContainer>
				)}
			</PresentationContainer>
			<ActionContainer>
				<Button
					width="260px"
					onClick={handleNavigate}
					disabled={!companySurvey.employee?.isProfileCompleted}
				>
					Siguiente
				</Button>
			</ActionContainer>
		</SurveyContainer>
	)
}
